import { Form, Step } from "./types";

export const defaultValues: Form = {
  a: "",
  goal: "",
  m: "",
  r: "",
  s: "",
  t: "",
};

export const steps: Step = {
  0: {
    title:
      "Defina exatamente o que você deseja alcançar. Seja claro e direto, evitando termos vagos como 'melhorar' ou 'crescer'.",
    placeholder: "Ex.: Aumentar as vendas do produto X.",
    field: "s",
  },
  1: {
    title:
      "Adicione métricas ou números que permitam acompanhar seu progresso. Pergunte-se: Como saberei se alcancei meu objetivo?",
    placeholder: "Ex.: Em 20% de crescimento nas vendas.",
    field: "m",
  },
  2: {
    title:
      "Certifique-se de que o objetivo é realista, considerando os recursos disponíveis e o contexto atual.",
    placeholder: "Ex.: Com campanhas no Instagram e um orçamento de R$ 10.000.",
    field: "a",
  },
  3: {
    title:
      "Explique como este objetivo está alinhado com suas prioridades e como ele impacta positivamente sua estratégia geral.",
    placeholder:
      "Ex.: Para aumentar o reconhecimento da marca e o faturamento.",
    field: "r",
  },
  4: {
    title:
      "Estabeleça um prazo claro para concluir o objetivo. Isso ajuda a criar um senso de urgência e manter o foco.",
    placeholder: "Ex.: Em 6 meses.",
    field: "t",
  },
};
